/*eslint-disable*/
import { Button, Grid, MobileStepper, LinearProgress, Typography,  FormControl, AppBar,Tab,	Tabs,} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import { reduxForm } from "redux-form";

import PersonalDetail from "./steps/PersonalDetail";
import BuySell from "./steps/BuySell";
import store from "store";
import { showSnack, successWarning } from "reducers/NotificationReducer";
import { FormHasErrors } from "helpers/ReduxHelpers";
import { DefaultInit } from "./bna_init";
import { SubmitFna } from "queries/fna/mutations";
import { FnaById } from "queries/fna/queries";
import { compose, graphql, Query } from "react-apollo";
import { get } from "lodash";
import { GetUserId, GetUserToken, GetUserKey } from "helpers/UserHelper";
import { ParseUriParams } from "helpers/UriReader";
import _ from "lodash";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";

import { ParseDMYwSlashes } from "helpers/DateHelpers";
import moment from "moment";
import {Field, change } from "redux-form";
import {businessOwner, Heir, KeyPerson, Purchaser, Surety} from "./steps/objects/bnaClasses.jsx"

const tabs = [
	'BNA Details',
  'Buy and Sell',
	
];

const tabStyle = {
	color: '#6c5cab',
	borderBottom: '2px solid'
};



const checkItem = (label, name, changeFunc) => {
  return (
    
    <GridItem xs={4} sm={4} md={2} >
            <FormControl style={{marginBottom: "-30px", paddingBottom: "-30px"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(h, f)

                }}

              />
            </FormControl>
            </GridItem>
  );
};


class BNAWizard extends React.Component {
  //Many of the defult values are set here, but only for the state object. The form fields' default values are set using the bna_init.js file.
    //Some changes will need to be made so as not to have to change the value twice for every default.
    //Also aware that this is not strictly the correct way of handling the form, But using the redux store is a pain and overly complex.
  state = {
    messageShown1 : false,
    checkValidation: false,
    editMode: false,
    clientId: null,
    client: null,
    entityType: "",
    marketValue: "0.00",
    buySell: "traditional",
    page: 0,

    businessOwners: [],
    heirs: [],
    keyPersons: [],
    sureties: [],
   
    
  };

  update = () =>
  {
    this.forceUpdate();
  }

  handleChangeTab = (event, value) => 
	{
    if (this.validationErrors())
    {
      return;
    } 
    else
    {
      this.state.page = value;
      this.forceUpdate();
    }
    
		
	};


  changeHeir = (value, name) =>
  {
    var classN = name.split(".")[0]
    var classO = name.split(".")[1].split("-")[0]
    var i =  name.split("-")[1]

    this.state[classN][i][classO] = value



    this.state.businessOwners.map((e, i) =>
    {
      var owner = e.name
      var ownerNumber = i
      e.minusInheritance = 0.00
      this.state.heirs.map((e, i) => 
      {
        if(e.to == owner)
        {
          this.state.businessOwners[ownerNumber].minusInheritance =1* this.state.businessOwners[ownerNumber].minusInheritance + 1* e.inherit;
          e.perantOwnership = this.state.businessOwners[ownerNumber].ownership;
        }
          

      })

    })

    
  };
  
  

  changePersonal = (value, name) =>
  {
    if(name.split(".").length > 2)
    {
      var classN = name.split(".")[0]
      var classO = name.split(".")[1]
      var classO2 = name.split(".")[2].split("-")[0]
      var classI = name.split("-")[1]
      if(name.split("-").length > 2)
      {
        var classI2 = name.split("-")[2]
        this.state[classN][classI][classO][classI2][classO2] = value
      }
      else
      {
        this.state[classN][classI][classO][classO2] = value
      }


      
      
      this.forceUpdate();
    }
    else
    if(name.split(".").length > 1)
    {
      var classN = name.split(".")[0]
      var classO = name.split(".")[1].split("-")[0]
      var classI = name.split("-")[1]
      console.log(classN)
      console.log(classO)
      console.log(classI)


      this.state[classN][classI][classO] = value
      console.log(name)
      console.log(value)
      this.forceUpdate();
    }
    else
    {
      if(name.split("-").length > 1)
      {
        var classN = name.split("-")[0]
        var classI = name.split("-")[1]
        this.state[classN][classI] = value
        this.forceUpdate();
      }
      else
      {
        this.state[name] = value
        this.forceUpdate();
      }
    }
    
  }

  changeEstateDuty = (value, name) =>
  {
    this.changePersonal(value, name);
    console.log("DUTYCHANGE " + classN + " . " +  classI )
    var classN = name.split(".")[0]
    var classO = name.split(".")[1].split("-")[0]
    var classI = name.split("-")[1]

    if(value == false)
    {
      this.state[classN][classI]["taxAmountPrev"] = this.state[classN][classI]["taxAmount"]
      this.state[classN][classI]["taxAmount"] = 0
      
      this.forceUpdate();
    }
    else
    {
      this.state[classN][classI]["taxAmount"] = this.state[classN][classI]["taxAmountPrev"];

      this.forceUpdate();
    }
    
  }

  
  
  changeTab = () =>
  {
    this.forceUpdate();
  }

  //whoof is just a temporary function for alerting changes that might break older BNA's when editing.
  whoof = () =>
{
  return(
    <div>
      <Typography style={{color: 'white'}}>
      <h4><b>Please note the following changes that might affect the BNA:</b> </h4>
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/> <b>New changes:</b>
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/> - Default values has been implemented.
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/><h4>NOTE: PLEASE CREATE A NEW BNA OR REFILL ALL THE DEFAULT FIELDS. ALL DEFAULT VALUES WILL TAKE EFFECT AS SOON AS CHANGES HAS BEEN ACCEPTED!</h4>
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/> <b>Previous Changes: </b>
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/> - Spouse spelling was corrected, all fields related will have invalid data
      </Typography>
      <Typography style={{color: 'white'}}>
      <br/> - Death is now the first option
      </Typography>
     
            
            
          
    </div>
  )
      
}
  
showChanges = () =>
{
  if(!this.state.changes1 && !this.state.messageShown1)
  {
    store.dispatch(
      showSnack({
        message: this.whoof(),
        color: "danger",
        timeout : "1"
      })
    );
    this.state.messageShown1 = true
  }
      
}
  

  validationErrors = () => {
    if (FormHasErrors("newbna", this.state.ignoreItems)) 
    {
      store.dispatch(
        showSnack({
          message: "Invalid Information",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      return true;
    }
    if(!this.state.changes1)
    {
      store.dispatch(
        showSnack({
          message: "Please accept that You acknowledge the changes.",
          color: "danger"
        })
      );
      this.setState({ checkValidation: true });
      return true;
    }
    this.setState({ checkValidation: false });
    return false;
  };

  nextPage = () => {
    if (this.validationErrors()) return;
    this.state.pageCount = 8; //This must be taken out. Only for testing!!!!
    const nextPage = this.state.page + 1;
    this.setState({ page: nextPage, checkValidation: false });
    this.forceUpdate();
  };

  previousPage = () => {
    if (this.validationErrors()) return;
    //this.setState({ checkValidation: false });
    const prevPage = this.state.page - 1;
    this.setState({ page: prevPage, checkValidation: false });
    this.forceUpdate();
  };

  setStepItems = (name, items) => {
    this.setState({ stepItems: { ...this.state.stepItems, [name]: items } });
  };

  initializeForm = (data = null, editMode) => 
  {
    if (data) 
    {
     
     
     
      if (!editMode) {
        this.props.initialize({ ...data, ...DefaultInit });
      } else 
      {
        this.setState(data.state)
        
        this.props.initialize(data);
        
      }
    } else {
      this.props.initialize(DefaultInit);
      
    }

    if (data.client.dob) {
      this.clientDobChanged(data.client.dob);
    }
    if(!editMode)
      this.setState({changes1: true})

    this.setState({ formInitiazed: true, editMode: data ? true : false });
    
  };

  checkAssistantActive() {
    if (GetUserKey("userType") === "6") {
      if (!this.state.assistantActive) {
        this.setState({ assistantActive: true });
      }
      return true;
    }
    return false;
  }

  getBrokerId = () => {
    let brokerId = GetUserId();
    if (this.checkAssistantActive()) {
      brokerId = sessionStorage.getItem("ActiveBrokerId");
    }
    return brokerId;
  };

  clientDobChanged = val => {
    try {
      if (val.length !== 10) throw "Too short";
      var dob = ParseDMYwSlashes(val);
      var age = moment().diff(dob, "years");
      store.dispatch(change("newbna", "client.age", age));
    } catch (error) {
      store.dispatch(change("newbna", "client.age", ""));
    }
    this.forceUpdate();
    return;
  };

  submit = () => {

    var formValues = get(store.getState().form, "newbna.values", {})
    formValues.state = this.state;
    if (this.validationErrors()) return;

    const input = {
      description: get(
        store.getState().form,
        "newbna.values.description",
        "Description"
      ),
      formData: JSON.stringify(get(store.getState().form, "newbna.values", {})),
      brokerId: this.getBrokerId(),
      clientId: this.state.clientId,
      token: GetUserToken()
    };

    this.props
      .SubmitBna({
        variables: {
          input
        }
      })
      .then(resp => {
        console.log("resp", resp);
        store.dispatch(
          successWarning({
            open: true,
            title: "BNA Submitted!",
           /* onConfirm: () =>
            
              this.props.history.push({
                pathname: "/app/fnaresults",
                search: `fnaId=${resp.data.SubmitFna.id}`
              })*/
          })
          
        );
        this.nextPage()
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  update = () =>
  {
    this.forceUpdate();
  }

  initializeDynamicField = (initializor, fields) =>
  {

    if(!this.state.changes1)
      return;


    /* field object: 
        
        fields = [] // list of fields to place default values
        field = 
        {
          field: "",      // the list that needs to be iterated. IE. the list that dictates the amount of dynamic fields to be initialized.
          fieldName: "",  // the field name that has to have a default value
          fieldVar: "",   // the variable that needs the default value
          value: "",      // the default value
          conditions: []  // optional list of conditions
        }
    */

    /* Condition object:
      conditions = [] // list of condition objects
      condition = 
      {
        condition: "", // the variable that needs to be compared
        param: ""      // the value to campare with
        falseValue: "" // optional value should comparison be false
      }
      */

     fields.map((e0, i0) => 
     {
      e0.field.replace("-", "")
        if(String(e0.field).split(".").length > 1)
        {
          
          console.log(e0.field.split(".")[0])
          console.log(e0.field.split(".")[1])
          console.log(this.state[e0.field.split(".")[0]])
          console.log(this.state[e0.field.split(".")[0]][e0.field.split(".")[1]])
        }
        else
        {
          console.log("WHOOF---" + e0.field)
        }


       if(e0.field.split(".").length > 1)
       this.state[e0.field.split(".")[0]][e0.field.split(".")[1]].map((e, i) => 
      {
        var fieldName = e0.fieldName + i;
        if(!e[initializor])
          e[initializor] = [];
        if(!e[initializor][i0])
        {
          if(e0.conditions == null)
          {
            this.props.change(fieldName, e0.value);
            e[e0.fieldVar] = e0.value;
            
          }
          else
          {
            var conditional = false
            e0.conditions.map((e1, i1) => 
            {
                if(e[e1.condition] == e1.param)
                {
                  this.props.change(fieldName, e0.value);
                  e[e0.fieldVar] = e0.value;
                  conditional = true;
                  return;
                }
                if(e1.falseValue != null && !conditional)
                {
                  this.props.change(fieldName, e1.falseValue);
                  e[e0.fieldVar] = e1.falseValue;
                }
            })
            
            this.forceUpdate();
          }
          e[initializor][i0] = true;
        }
      })
      else
      this.state[e0.field].map((e, i) => 
      {
        var fieldName = e0.fieldName + i;
        if(!e[initializor])
          e[initializor] = [];
        if(!e[initializor][i0])
        {
          if(e0.conditions == null)
          {
            this.props.change(fieldName, e0.value);
            e[e0.fieldVar] = e0.value;

            console.log(fieldName + " ----- " + e0.value + " >>> " + i0)
            
          }
          else
          {
            var conditional = false
            e0.conditions.map((e1, i1) => 
            {
                if(e[e1.condition] == e1.param)
                {
                  this.props.change(fieldName, e0.value);
                  e[e0.fieldVar] = e0.value;
                  conditional = true;
                  return;
                }
                if(e1.falseValue != null && !conditional)
                {
                  this.props.change(fieldName, e1.falseValue);
                  e[e0.fieldVar] = e1.falseValue;
                }
            })
            
            this.forceUpdate();
          }
          e[initializor][i0] = true;
        }
      })

      
     })


    
    
  }

  addOwner()
  {
    var owners = this.state.businessOwners
    var newOwner = new businessOwner
   

    
    owners.map((e, i) => 
    {
      var newPurchaser = new Purchaser;
      newPurchaser.ownerRef = e;
      newPurchaser.purchaseFrom = newOwner
      newOwner.saleOnDeath.push(newPurchaser)

      var newPurchaserOwner = new Purchaser;
      newPurchaserOwner.ownerRef = newOwner;
      newPurchaserOwner.purchaseFrom = e
      e.saleOnDeath.push(newPurchaserOwner)
    })



    owners.push (newOwner)
    this.setState({businessOwners: owners})


  }

  addPurchaser()
  {
    var owners = this.state.businessOwners
    var newOwner = new businessOwner
    newOwner.isOwner = false
   

    
    owners.map((e, i) => 
    {
      var newPurchaser = new Purchaser;
      newPurchaser.ownerRef = e;
      newPurchaser.purchaseFrom = newOwner
      newOwner.saleOnDeath.push(newPurchaser)

      var newPurchaserOwner = new Purchaser;
      newPurchaserOwner.ownerRef = newOwner;
      newPurchaserOwner.purchaseFrom = e
      e.saleOnDeath.push(newPurchaserOwner)
    })



    owners.push (newOwner)
    this.setState({businessOwners: owners})
  }

  addHeir()
  {
    var heirs = this.state.heirs
    heirs.push (new Heir)

    this.setState({heirs: heirs})
  }

  addKeyPerson()
  {
    var keyPersons = this.state.keyPersons
    keyPersons.push (new KeyPerson)

    this.setState({keyPersons: keyPersons})
  }

  addSurety()
  {
    var sureties = this.state.sureties
    sureties.push (new Surety)

    this.setState({sureties: sureties})
  }

  removeEntity(n, item)
    {
      var entity = this.state[item];
      var newEntity = [];
      var node = n.target;
      
      while(node.nodeName != "BUTTON" && node.parentNode != null)
      {
        node = node.parentNode
      }
      
      var i = node.name.replace("remove", "")
      
      
      console.log(JSON.stringify(entity))
      entity.map((e,k) =>
      {
        if(e != entity[i])
          newEntity[k] = e
        if(e == entity[i])
        {
          entity[i].deleted = true
        }
         
      })
    
      this.state[item] = newEntity;
      this.forceUpdate();
    //this.setState({businessOwners: newOwner})
  }

  removeOwner(n)
  {
    var owners = this.state.businessOwners;
    var newOwner = [];
    var node = n.target;
    
    while(node.nodeName != "BUTTON" && node.parentNode != null)
    {
      node = node.parentNode
    }
    
    var i = node.name.replace("remove", "")
    console.log(owners)
    
    
    owners.map((e,k) =>
    {
      console.log(e + " --- " + owners[i])
      if(e != owners[i])
        newOwner[k] = e
      if(e == owners[i])
      {
        owners[i].deleted = true
      }
       
    })
    this.setState({businessOwners: newOwner})
    this.cleanOwners();
    this.forceUpdate()


  }

  cleanOwners()
  {
    this.state.businessOwners.map((e,i) =>
    {
      e.saleOnDeath.map( (e,i) =>
      {
        console.log(e.ownerRef)
        if(e.ownerRef.deleted)
          e.purchaseFrom.saleOnDeath.splice(i, 1)
      })
    })

    this.state.businessOwners.map((e,i) =>
    {
      if(e.deleted)
        this.state.businessOwners.splice(i, 1);
      
    })
  }

    

  render() {
   
    const params = ParseUriParams(this.props.location.search);
    this.state.params = params;
    const { id, clientId } = params;
    const { page } = this.state;
    if(!this.state.changes1 && this.state.formInitiazed)
    {
      
      this.showChanges()
    }
    return (
      <Query
        query={FnaById}
        variables={{
          clientId: 35,
          fnaId: id ? id : null
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data }) => {
          if (loading)
            return (
              <div>
                <LinearProgress />
              </div>
            );
          if (error) return `Error! ${error.message}`;

          const form_data = _.get(data, "FnaById.form_data", null);
          const editMode = _.get(data, "FnaById.editMode", false);

          const formData = form_data ? JSON.parse(form_data) : null;
             
          
          if(formData)
            this.client = formData.client

          console.log(this.client)

          if (!this.state.formInitiazed) {
            this.initializeForm(formData, editMode);
            this.setState({ clientId: clientId });
            this.setState({client: formData.client})
          }

          return (
            <Grid container>
              <GridItem
                xs={12}
                sm={12}
                md={10}
                style={{ margin: "auto", width: "100%" }}
              >
                <div className={"fixedStepper"}>
                  <Grid container>
                    <GridItem
                      xs={12}
                      sm={12}
                      md={10}
                      style={{flexBasis: "100%", maxWidth: "100%", margin: 'auto' }}
                    >
                      <div className={"stepperDiv"}>
                        <MobileStepper
                          type="progress"
                          steps={this.state.pageCount}
                          position="static"
                          activeStep={this.state.page}
                          nextButton={
                            <div style={{ display: "flex" }}>
                              {this.state.page === this.state.pageCount - 1 ? (
                                <Button
                                  variant="outlined"
                                  className="outlinedButton"
                                  color="secondary"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => this.submit()}
                                >
                                  Submit
                                </Button>
                              ) : (
                                <div />
                              )}

                              {this.state.page ===
                              this.state.pageCount - 1 ? null : (
                                <Button
                                  variant="outlined"
                                  className="outlinedButton"
                                  color="secondary"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => this.nextPage()}
                                >
                                  Next
                                </Button>
                              )}
                            </div>
                          }
                          backButton={
                            <Button
                              variant="outlined"
                              className="outlinedButton"
                              color="secondary"
                              style={{ marginLeft: "10px" }}
                              onClick={() => this.previousPage()}
                              disabled={this.state.page === 0 ? true : false}
                            >
                              Back
                            </Button>
                          }
                        />
                      </div>
                    </GridItem>
                  </Grid>
                </div>
                <br />
        
                {
                      !this.state.changes1  &&
                      <GridItem xs={24} sm={24} md={6} style={{ marginBottom: '25px' }}>
                        <br/><br/><br/>
                      <Grid container>
                        <GridItem xs={6} sm={6} md={10} style={{ marginBottom: '0px' }}>
                          <Typography style={{fontSize: '16px'}}>
                            Changes to the BNA has been made. Please confirm that all information is correct.
                          </Typography>
                    </GridItem>
                    
                        

                     
                      {checkItem("", "changes1", this.changePersonal)}
                      </Grid>
                      </GridItem>
                      
                    }

                    <AppBar
											position="static"
											color="default"
											style={{ marginBottom: '-20px', marginTop: '10px', marginLeft: "25px" }}
										>
											<Tabs
												tab={this.state.page}
												onChange={this.handleChangeTab}
												indicatorColor="primary"
												textColor="secondary"
												scrollable
                        scrollButtons="auto"
                        
											>
												{tabs.map((t, i) => {
													return (
														<Tab label={t} style={i === this.state.page ? tabStyle : {marginRight: "-15px"}} />
													);
												})}
											</Tabs>
										</AppBar>
                {page === 0 && (
                  <PersonalDetail
                  
                    checkValidation={this.state.checkValidation}
                    scrollMeBar={this.props.scrollMeBar}
                    changePersonal={this.changePersonal.bind(this)}
                    changeHeir = {this.changeHeir.bind(this)}
                    addOwner={this.addOwner.bind(this)}
                    addPurchaser={this.addPurchaser.bind(this)}
                    addHeir={this.addHeir.bind(this)}
                    addKeyPerson={this.addKeyPerson.bind(this)}
                    addSurety={this.addSurety.bind(this)}
                    removeOwner={this.removeOwner.bind(this)}
                    removeEntity={this.removeEntity.bind(this)}
                    update={this.update.bind(this)}
                    state={this.state}
                  />
                )}

                {page === 1 && (
                  <BuySell
                    checkValidation={this.state.checkValidation}
                    scrollMeBar={this.props.scrollMeBar}
                    initializeDynamicField = {this.initializeDynamicField.bind(this)}
                    changePersonal={this.changePersonal.bind(this)}
                    changeEstateDuty = {this.changeEstateDuty.bind(this)}
                    addOwner={this.addOwner.bind(this)}
                    addPurchaser={this.addPurchaser.bind(this)}
                    addHeir={this.addHeir.bind(this)}
                    addKeyPerson={this.addKeyPerson.bind(this)}
                    addSurety={this.addSurety.bind(this)}
                    removeOwner={this.removeOwner.bind(this)}
                    removeEntity={this.removeEntity.bind(this)}
                    update={this.update.bind(this)}
                    state={this.state}
                  />
                )}
               
               
              </GridItem>
            </Grid>
          );
        }}
      </Query>
    );
  }
}

BNAWizard = reduxForm({
  form: "newbna",
  destroyOnUnmount: true
})(BNAWizard);

BNAWizard = compose(graphql(SubmitFna, { name: "SubmitBna" }))(BNAWizard);

export default BNAWizard;



// WEBPACK FOOTER //
// ./src/views/Bna/bna_wizard.jsx